import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import moment from 'moment';

import { LocalShipping, Delete, Visibility } from '@material-ui/icons';

import { ADM, GFO, GPP, FRENTISTA } from '~/constants/perfil';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoRecebimento,
  recordFiltering,
} from '~/store/modules/operacaorecebimento/actions';

//import OperacaoRecebimentoForm from './form';
import Deletar from './components/Deletar';
import GPPConfirmar from './components/GPPConfirmar';
import Detalhe from './components/Detalhe';

function OperacaoRecebimento() {
  const deletarRegRef = useRef(null);
  const gppConfirmarRef = useRef(null);
  const detalheRef = useRef(null);

  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const buttons = [];
  const operacaorecebimento = useSelector((state) => state.operacaorecebimento);

  const [habAlterar, setHabAlterar] = useState(false);
  const [habDetalhe, setHabDetalhe] = React.useState(false);

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.gloperfilid) {
        case ADM:
          setHabAlterar(false);
          setHabDetalhe(true);
          break;
        case GPP:
        case GFO:
        case FRENTISTA:
          setHabAlterar(true);
          setHabDetalhe(true);
          break;
        default:
          setHabAlterar(false);
          setHabDetalhe(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const handleUpdate = React.useCallback(async () => {
    await dispatch(recordFiltering(operacaorecebimento.params));
  }, [operacaorecebimento]);

  const handleDeletarReg = React.useCallback(
    (values) => {
      if (values.prre_codigo !== 0) {
        toast.error(
          'Não é permitido essa operação se o recebimento é de um recebimento provisório!'
        );
        return;
      }
      if (verificarPendenciaExcluir(values)) {
        return;
      }
      deletarRegRef.current.handleToggleModal(values);
    },
    [deletarRegRef]
  );

  const handleConfirmarReg = React.useCallback(
    (values) => {
      if (profile.gloperfilid === 6) {
        if (values.prre_codigo !== 0) {
          toast.error(
            'Não é permitido essa operação se o recebimento é de um pré-recebimento!'
          );
          return;
        }
      }
      if (verificarPendenciaConfirmar(values)) {
        return;
      }
      gppConfirmarRef.current.handleToggleModal(values);
    },
    [gppConfirmarRef]
  );

  const handleDetalheReg = React.useCallback(
    (values) => {
      detalheRef.current.handleToggleModal(values);
    },
    [detalheRef]
  );

  const verificarPendenciaExcluir = React.useCallback((values) => {
    if (profile.gloperfilid === 6) {
      if (values.desc_pendente === 'S') {
      } else {
        if (values.desc_pendente !== 'A') {
          if (values.desc_pendente === 'N') {
          } else {
          }
        } else {
          toast.error(
            'Não é permitido essa operação no registro de recebimento!'
          );
          return true;
        }
      }
    } else if (profile.gloperfilid === 3) {
      if (values.desc_pendente_orgao === 'S') {
      } else {
      }
    } else if (profile.gloperfilid === 7) {
      if (values.desc_pendente === 'S' || values.desc_pendente_orgao === 'S') {
        toast.error(
          'Não é permitido essa operação no registro de recebimento!'
        );
        return true;
      } else {
      }
    }
  }, []);

  const verificarPendenciaConfirmar = React.useCallback((values) => {
    if (profile.gloperfilid === 6) {
      if (values.desc_pendente === 'S') {
      } else {
        toast.error(
          'Não é permitido essa operação no registro de recebimento!'
        );
        return true;
      }
    } else if (profile.gloperfilid === 3) {
      if (values.desc_pendente_orgao === 'S') {
      } else {
        toast.error(
          'Não é permitido essa operação no registro de recebimento!'
        );
        return true;
      }
    } else if (profile.gloperfilid === 7) {
      if (values.desc_pendente === 'S' || values.desc_pendente_orgao === 'S') {
      } else {
      }
    }
  }, []);

  const header = React.useMemo(
    () => [
      {
        id: 'poco_codigo',
        label: 'Posto Código:',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_descricao',
        label: 'Posto Descrição',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'desc_data_inicio',
        label: 'Data',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
      },
      {
        id: 'prod_display',
        label: 'Produto',
        align: 'left',
      },
      {
        id: 'desc_nf',
        label: 'Nota Fiscal',
        align: 'right',
      },
      {
        id: 'prre_codigo',
        label: 'Recebimento Provisório',
        align: 'right',
      },
      {
        id: 'desc_volume_nf',
        label: 'Volume NF',
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'desc_status_pendencia',
        label: 'Status Liberação',
        align: 'left',
      },
    ],
    []
  );

  const headerbuttons = useMemo(
    () => [
      habAlterar &&
        (profile.gloperfilid === 3) &
          (itemSelecionado.desc_pendente_orgao === 'S') &&
        buttons.push({
          title: 'Confirmar Recebimento',
          action: (value) => handleConfirmarReg(value),
          icon: <LocalShipping />,
        }),

      habAlterar &&
        (profile.gloperfilid === 6) & (itemSelecionado.desc_pendente === 'S') &&
        buttons.push({
          title: 'Confirmar Recebimento',
          action: (value) => handleConfirmarReg(value),
          icon: <LocalShipping />,
        }),

      habDetalhe &&
        buttons.push({
          title: 'Detalhe Recebimento',
          action: (value) => handleDetalheReg(value),
          icon: <Visibility />,
        }),

      profile.gloperfilid === 6 &&
        buttons.push({
          title: 'Excluir',
          action: (value) => handleDeletarReg(value),
          icon: <Delete />,
        }),
    ],
    [operacaorecebimento, itemSelecionado, profile, habAlterar, habDetalhe]
  );

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaorecebimento]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="desc_codigo ASC"
        title={'Recebimento em Andamento'}
        create={false}
        update={false}
        fixed
        header={header}
        find={findOperacaoRecebimento}
        redux={operacaorecebimento}
        read={recordFiltering}
        actions={buttons}
        detach="desc_codigo"
        keys="desc_codigo"
        maxWidth="md"
        onRow={(values) => registroSelecionado(values)}
        view="vw_descarga_andamento"
        reportTitle="Recebimento em Andamento"
      />

      <Deletar
        ref={deletarRegRef}
        update={() => handleUpdate()}
        name="deletarRegRef"
      />

      <GPPConfirmar
        ref={gppConfirmarRef}
        update={() => handleUpdate()}
        name="gppConfirmarRef"
      />

      <Detalhe ref={detalheRef} update={() => handleUpdate()} name="Detalhe" />
    </>
  );
}

export default OperacaoRecebimento;
